export default class PvApiUnsupportedMediaTypeException extends Error {
    constructor() {
        super();
        this.name = '415 Unsupported Media Type';
        this.message = 'Не поддерживаемый тип данных';
    }
}